import cn from "classnames"

import { Flex } from "@/atoms"
import * as AdrDomain from "@/domain/adr"
import { getDate, getRelativeTimeFromNow } from "@/helpers/date.helpers"
import { useTranslation } from "@/hooks/useTranslation"
import { HddOutlined, SafetyCustom } from "@/icons"
import { PriorityLabel } from "@/pages/TriagePage/components/pages/AdrManagementPage/components/molecules/PriorityLabel"

import styles from "./IncidentCard.module.scss"

import type { IncidentCardProps } from "./IncidentCard.types"

export const IncidentCard = (props: IncidentCardProps) => {
  const { incident, inline, className, isFlash, onOpen } = props
  const { t } = useTranslation()

  if (!incident) return null

  const { name, priority, category, where, detectedAt } = incident
  const { namespace, environment } = where || {}
  const detectedAtDate = getDate(detectedAt)
  const TWELVE_HOURS_IN_MS = 43200000
  const isNew =
    getDate().valueOf() - detectedAtDate.valueOf() < TWELVE_HOURS_IN_MS
  const nameLength = name.length

  return (
    <div
      className={cn(
        styles.wrapper,
        isFlash && cn(styles.wrapperFlash, "flash-incident-card")
      )}
      onClick={() => onOpen(incident)}
    >
      <div className={cn(styles.container, className)}>
        <Flex justify="space-between">
          <span
            style={{
              maxWidth: inline ? "100%" : `${nameLength - nameLength / 3}ch` // title should be in two lines and one line if inline
            }}
            className={styles.title}
          >
            {name}
          </span>
          {inline && (
            <PriorityLabel
              reverse
              level={7}
              priority={priority}
              className={styles.priority}
            />
          )}
        </Flex>
        <section className={styles.section}>
          <div
            className={cn(
              styles.description,
              inline && styles.descriptionInline
            )}
          >
            <SafetyCustom />
            <span className={styles.descriptionText}>{category}</span>
            {inline && <span />}
            <HddOutlined />
            <span className={styles.descriptionText}>
              {AdrDomain.isVM(incident)
                ? `${environment}`
                : `${environment} / ${namespace}`}
            </span>
          </div>
          {!inline && (
            <div className={styles.metadata}>
              <span className={styles.textSecondary}>
                {getRelativeTimeFromNow(detectedAtDate)}
              </span>
              {isNew && (
                <span className={styles.newBadge}>{t("general.new")}</span>
              )}
            </div>
          )}
        </section>
      </div>
    </div>
  )
}
